import styled, { createGlobalStyle } from 'styled-components';

export const MembersListFiltersGlobalStyle = createGlobalStyle`
  .members-list-filters .collapse-toggle {
    background-color: #E9E7F8 !important;
    border-radius: 8px 8px 0 0 !important;
    padding: 16px 20px !important;
    border-bottom: 1px solid #e9ecef !important;
  }

  .members-list-filters .collapse-content {
    padding: 0px !important;
  }

  .members-list-filters .collapse {
    background: #fff !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    margin-bottom: 20px !important;
  }
`;

export const FiltersContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  position: relative;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;

export const FilterSectionTitle = styled.h4`
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FilterLabel = styled.div`

`;

export const ActiveFiltersIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #6c5ce7;
  color: white;
  padding: 4px 8px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
`;

export const FilterCount = styled.span`
  background-color: white;
  color: #6c5ce7;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
`;

export const FilterGroupTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: 100%;
  border-bottom: 1px solid rgb(242 242 242);
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  /* Hacer que cada hijo ocupe el mismo ancho */
  & > * {
    flex: 1;
    min-width: 0; /* Permite que los elementos se reduzcan */
  }

  /* Responsive: en móvil cambiar a columna */
  @media (max-width: 768px) {
    flex-direction: column;
    
    & > * {
      flex: none; /* En móvil no necesitamos flex: 1 */
    }
  }

  label {
    color: #666;
    margin-bottom: 4px;
  }
`;